import { Router } from 'pjax';
import dashboard from './dashboard.js';

Router.get('judging/dashboard', dashboard);
